import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import store from 'store';
import { RouterProvider } from 'react-router-dom';

import '../../i18n';
import { OperatorProvider } from '@/contexts/OperatorContext';
import FeatureFlagsProvider from './feature-flags/FeatureFlagsProvider';
import router from './routes';
import ApolloWrapper from './apollo/ApolloWrapper';
import AuthWrapper from './auth/AuthWrapper';
import { useSubdomain } from './hooks/useSubdomain';
import ThemeProvider from './ThemeProvider';
import { useSubdomainRedirect } from "hooks/useSubdomainRedirect";

const AppWrapper: React.FC = () => {
    const { subdomain } = useSubdomain();

    const shouldRender = useSubdomainRedirect();

    if (!shouldRender) {
        return null;
    }

    return (
        <OperatorProvider subdomain={subdomain}>
            <AuthWrapper>
                <ReduxProvider store={store}>
                    <ApolloWrapper>
                        <ThemeProvider>
                            <FeatureFlagsProvider>
                                <RouterProvider router={router} />
                            </FeatureFlagsProvider>
                        </ThemeProvider>
                    </ApolloWrapper>
                </ReduxProvider>
            </AuthWrapper>
        </OperatorProvider>
    );
};

export default AppWrapper;
